var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 125.198,
    viewBox: "0 0 140 125.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blockchain_1_",
    "data-name": "blockchain (1)",
    transform: "translate(0 -27.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(0 76.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M45.625,229.306,7.141,207.013A4.758,4.758,0,0,0,0,211.132v44.361a4.76,4.76,0,0,0,2.372,4.118L40.856,281.9A4.756,4.756,0,0,0,48,277.785V233.422A4.757,4.757,0,0,0,45.625,229.306Zm-7.141,40.225L10.215,253.158a1.409,1.409,0,0,1-.7-1.219V219.382l28.972,16.78Z",
    transform: "translate(0 -206.374)",
    fill: "#fca62f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M45.625,229.306,7.141,207.013A4.758,4.758,0,0,0,0,211.132v9.9l9.513,5.51v-7.161l28.972,16.78v7.127a10.945,10.945,0,0,0,9.513,0v-9.868a4.757,4.757,0,0,0-2.372-4.116Z",
    transform: "translate(0 -130.279)",
    fill: "#fb9927"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(38.485 76.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M186.358,207.011a4.747,4.747,0,0,0-4.758.005l-38.484,22.29a4.759,4.759,0,0,0-2.372,4.115v44.363a4.754,4.754,0,0,0,7.141,4.115l38.484-22.29a4.759,4.759,0,0,0,2.372-4.116V211.133a4.75,4.75,0,0,0-2.383-4.121Zm-7.832,46.148-26.155,15.149a1.409,1.409,0,0,1-2.114-1.219V236.164l28.972-16.78V251.94A1.407,1.407,0,0,1,178.526,253.159Z",
    transform: "translate(-140.744 -206.375)",
    fill: "#fcc16d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(72.898 115.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M280.183,349.436v9.68l-.008.01-8.482,1.625a4.759,4.759,0,0,1-4.49-1.558l-.6-.7,3.368-1.951a1.409,1.409,0,0,0,.7-1.219v-6.656l1.921,2.217Z",
    transform: "translate(-266.6 -348.672)",
    fill: "#fca62f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M186.358,207.011a4.747,4.747,0,0,0-4.758.005l-38.484,22.29a4.759,4.759,0,0,0-2.372,4.115v9.868a10.945,10.945,0,0,0,9.513,0v-7.127l28.972-16.78v7.163l9.513-5.51v-9.9a4.75,4.75,0,0,0-2.383-4.121Z",
    transform: "translate(-102.259 -130.28)",
    fill: "#fca62f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 53.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M43.241,178.948a4.752,4.752,0,0,1-2.384-.641L2.373,156.016a4.757,4.757,0,0,1,0-8.232l38.484-22.291a4.757,4.757,0,0,1,4.768,0l38.484,22.291a4.757,4.757,0,0,1,0,8.232L45.625,178.307A4.755,4.755,0,0,1,43.241,178.948Zm-26.89-25.829,26.184,15.167a1.409,1.409,0,0,0,1.412,0L70.13,153.119a1.408,1.408,0,0,0,0-2.437L43.947,135.515a1.409,1.409,0,0,0-1.412,0L16.351,150.681a1.408,1.408,0,0,0,0,2.437Z",
    transform: "translate(0 -124.852)",
    fill: "#ffd496"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(52.499 76.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M225.978,212.435a4.759,4.759,0,0,1-2.372,4.115l-3.239,1.876L192,223.866l19.735-11.431-2.648-1.532,14.262-2.735.262.152A4.755,4.755,0,0,1,225.978,212.435Z",
    transform: "translate(-191.995 -208.167)",
    fill: "#fcc16d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(43.273 69.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M239.351,216.02l-29.065-33.514a4.754,4.754,0,0,0-4.49-1.555l-43.677,8.372a4.757,4.757,0,0,0-2.7,7.787l6.689,7.714,8.383-4.855-2.479-2.86,32.881-6.3,21.862,25.211-32.084,6.148a1.408,1.408,0,0,1-1.329-.46l-12.5-14.421-8.383,4.855,16.029,18.483a4.76,4.76,0,0,0,4.49,1.558l43.677-8.372a4.759,4.759,0,0,0,2.7-7.79Z",
    transform: "translate(-158.257 -180.865)",
    fill: "#2944ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(86.951 27.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M354.931,110.986a4.757,4.757,0,0,1-6.71-.477L319.156,76.993a4.757,4.757,0,0,1-.9-4.664l14.47-42.054a4.757,4.757,0,0,1,8.092-1.569l29.065,33.516a4.757,4.757,0,0,1,.9,4.664l-14.47,42.054A4.755,4.755,0,0,1,354.931,110.986ZM328.14,72.832,348.4,96.2a1.408,1.408,0,0,0,2.4-.465l9.834-28.579a1.409,1.409,0,0,0-.268-1.381l-21.33-24.6Z",
    transform: "translate(-317.993 -27.066)",
    fill: "#627be6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M340.816,28.707a4.754,4.754,0,0,0-8.09,1.569l-14.47,42.053a4.757,4.757,0,0,0,.9,4.665l6.462,7.454a10.928,10.928,0,0,0,7.186-6.237l-4.665-5.38,10.893-31.656,4.69,5.409L347.3,36.189Z",
    transform: "translate(-231.045 -0.001)",
    fill: "#3351c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(43.272 27.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M224.753,28.706a4.755,4.755,0,0,0-4.488-1.555l-43.68,8.372a4.757,4.757,0,0,0-3.6,3.123L166.395,57.8l8.388,4.86,6.035-17.538a1.408,1.408,0,0,1,1.067-.925L211.6,38.5a1.409,1.409,0,0,1,1.6,1.841L203.355,68.95a1.408,1.408,0,0,1-1.067.925l-29.718,5.7a1.409,1.409,0,0,1-1.6-1.842l.657-1.908-8.391-4.86L158.512,80.7a4.757,4.757,0,0,0,5.4,6.219l43.677-8.372a4.761,4.761,0,0,0,3.6-3.123L225.658,33.37a4.76,4.76,0,0,0-.905-4.664Z",
    transform: "translate(-158.254 -27.065)",
    fill: "#7c91ea"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.baa5dd441b3a6359efa0fe4f38591553.svg";
export { ForwardRef as ReactComponent };